<template>
  <div
          class="collapsible slider"
          :style="element_style"
          :class="{closed: $root.step < step}"
  >
    <h2
            class="slider clickable"
            style="max-height: 100px;"
            :class="{closed: $root.step <= step}"
            @click="$root.step = step"
    >
      <span class="step">Step {{step}}</span>
      <br />
      <span v-html="label"></span>
    </h2>
    <form
            ref="form"
            class="slider"
            :style="element_style"
            :class="{closed: $root.step > step}"
            @submit.prevent="next"
    >
      <div v-if="label" class="step-label">{{step}}</div>
      <slot></slot>
      <button v-if="has_next" class="btn btn-primary btn-next">Next</button>
      <div v-if="$root.step === 4 || $root.step === '4'">
        <button
          class="btn btn-primary btn-skip-step"
          @click="$root.skipped_bottoms = true"
        >Skip step</button>
      </div>
    </form>
  </div>
</template>

<script>
  import $ from "jquery";

  export default {
    data(){
      return {
        collapsed: false,
      }
    },
    props: {
      step: Number,
      label: String,
      has_next: {
        type: Boolean,
        default: false,
      },
      max_height: Number,
    },
    computed:{
      element_style(){
        return {
          'max-height': this.max_height + 'px',
        }
      }
    },
    watch: {
      '$root.step': function (newStep, oldStep) {
        if(newStep === this.step){
          setTimeout(
            this.focus,
            800
          );
        }
      }
    },
    methods:{
      next(){
        $(this.$el).find('input').blur();
        this.$root.step++;
      },
      focus(){
        $('html, body').animate(
          {scrollTop: ($(this.$el).offset().top)},
          500,
          'swing',
          () => $(this.$el).find('input:first').focus()
        );
      },
    },
  }
</script>

<style lang="less" scoped>
  h2.slider {
    margin-top: 0;
  }

  .slider {
    overflow-y: hidden;

    transition-property: all;
    transition-duration: .75s;
    transition-timing-function: linear;

    &.closed {
      max-height: 0!important;
      margin: 0;
      padding: 0;
      border: none;
    }
  }
</style>
